import { render, staticRenderFns } from "./StatisticsItem.vue?vue&type=template&id=4cc7f4bf&scoped=true&"
import script from "./StatisticsItem.vue?vue&type=script&lang=js&"
export * from "./StatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsItem.vue?vue&type=style&index=0&id=4cc7f4bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7f4bf",
  null
  
)

export default component.exports